import styled, { css } from 'styled-components';

export const StyledIconButton = styled.button(
  ({ theme, disabled }) => css`
    background-color: inherit;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${disabled ? '0.3' : '1'};
    padding: 0;
  `
);

export const TitleContainer = styled.div`
    font: inherit;
    font-size: ${({theme}) => theme.fontSize.m};
    color: ${({theme}) => theme.colors.dimGray};
`;

export const LeftIconContainer = styled.div`
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

export const RightIconContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacing.s};
`;
